const brands = {
  getBrands: () => "api/get-all-brands",
  getBanner: () => "api/get-all-banners/1",
};

export default brands;
